import { Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function BreadcrumbCRM({active}) {

    return <Breadcrumb>
            <Breadcrumb.Item><Link to="/">Inicio</Link></Breadcrumb.Item>
            <Breadcrumb.Item><Link to="/crm">CRM</Link></Breadcrumb.Item>
            <Breadcrumb.Item active>{active}</Breadcrumb.Item>
        </Breadcrumb>
    
}